import * as React from 'react';
import classNames from 'classnames';
import { insetPropDefs } from './inset.props';
import { extractMarginProps, withMarginProps, withBreakpoints } from '../helpers';
const Inset = React.forwardRef((props, forwardedRef) => {
    const { rest: marginRest, ...marginProps } = extractMarginProps(props);
    const { className, side = insetPropDefs.side.default, clip = insetPropDefs.clip.default, p, px, py, pt, pr, pb, pl, ...insetProps } = marginRest;
    return (React.createElement("div", { ...insetProps, ref: forwardedRef, className: classNames('rt-Inset', className, withBreakpoints(side, 'rt-r-side'), withBreakpoints(clip, 'rt-r-clip'), withBreakpoints(p, 'rt-r-p'), withBreakpoints(px, 'rt-r-px'), withBreakpoints(py, 'rt-r-py'), withBreakpoints(pt, 'rt-r-pt'), withBreakpoints(pr, 'rt-r-pr'), withBreakpoints(pb, 'rt-r-pb'), withBreakpoints(pl, 'rt-r-pl'), withMarginProps(marginProps)) }));
});
Inset.displayName = 'Inset';
export { Inset };
//# sourceMappingURL=inset.js.map